import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import SportPraticati from "../Clienti/SportPraticati";

const SportJunior = (props) => {

    const [formData, setFormData] = useState({ assicurato: '', primaryHand: '', primaryFoot: '' });

    useEffect(() => {
        if (props.profile && props.profile.junior) {
            const j = props.profile.junior;

            let primaryHand = j.primaryHand || '';
            let primaryFoot = j.primaryFoot || '';
            if (primaryHand === 'RIGHT') primaryHand = 'Destra';
            if (primaryHand === 'LEFT') primaryHand = 'Sinistra';
            if (primaryHand === 'AMBIDEXTROUS') primaryHand = 'Ambidestro';
            if (primaryFoot === 'RIGHT') primaryFoot = 'Destro';
            if (primaryFoot === 'LEFT') primaryFoot = 'Sinistro';
            if (primaryFoot === 'AMBIDEXTROUS') primaryFoot = 'Ambidestro';

            setFormData({ assicurato: j.insured ? 'Si' : 'No', primaryHand, primaryFoot });

        }
    }, [props]);


    return (
        <Row>
            <Form>
                <Card className="cardAuto">
                    <Card.Header><h4 className="card-title">Informazioni generiche</h4></Card.Header>
                    <Card.Body>
                        <Row className="mt-3">
                            <Col lg={4}>
                                <Form.Label>Mano primaria</Form.Label>
                                <Form.Control className="sid-ro-input" type="text" value={formData.primaryHand} readOnly tabIndex={-1} />
                            </Col>
                            <Col lg={4}>
                                <Form.Label>Piede primario</Form.Label>
                                <Form.Control className="sid-ro-input" type="text" value={formData.primaryFoot} readOnly tabIndex={-1} />
                            </Col>
                            <Col lg={4}>
                                <Form.Label>Assicurato</Form.Label>
                                <Form.Control className="sid-ro-input" type="text" value={formData.assicurato} readOnly tabIndex={-1} />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <SportPraticati userId={props.profile?.junior?.userId} sports={props.profile?.junior?.sports} conStaff={false} />
            </Form>
        </Row>
    );
};

export default SportJunior;
